import script from "./TopUpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopUpPage.vue?vue&type=script&setup=true&lang=ts"

import "./TopUpPage.vue?vue&type=style&index=0&id=9813cbf8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9813cbf8"]])

export default __exports__